/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTopmatchDetailGroup.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/topmatch-detail-group";

export class AutogenModelTopmatchDetailGroup<RowType extends ModelRow> extends Endpoint<RowType, RowTopmatchDetailGroupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTopmatchDetailGroup extends ModelRow<RowTopmatchDetailGroupFields> {
	constructor(values?: Partial<RowTopmatchDetailGroupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTopmatchDetailGroupFields {
	company_id: string;
	comparison: string;
	comparison_value: number;
	id: string;
	parent_row_id: string;
	score: number;
	sequence: number;
}

